import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/**
 * Format a version string for display. ARX content-addresses some
 * versions with a long hex hash (e.g. a tulpa packed by arx-web carries
 * a 64-char sha as its version). A raw hash reads as noise next to a
 * `v1.2.3`, so we render hashes as a short monospace `#abc1234` chip and
 * leave human versions as `v1.2.3`.
 */
export function formatVersion(version: string): { label: string; isHash: boolean } {
  const isHash = /^[0-9a-f]{16,}$/i.test(version);
  if (isHash) {
    return { label: `#${version.slice(0, 7)}`, isHash: true };
  }
  return { label: `v${version}`, isHash: false };
}
